import React from 'react'

import { ShortcutTooltip } from 'components/ui/ShortcutTooltip'
import { useCatalogFilterSidebar } from 'features/catalog/hooks/use-catalog-filter-sidebar'
// bully ignore[no-cross-feature-private-imports: ControlsSidebar is the shared shell charts-v2 already exports for reuse — same direct-submodule-path ignore Feedback/Keywords already carry (barrel import is deliberately avoided per no-cross-feature-barrel-imports). follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import { ControlsSidebar } from 'features/charts-v2/components/ControlsSidebar/ControlsSidebar'
import { GLOBAL_SHORTCUT_KEYS } from 'hooks/keyboard-shortcuts'
import { useShortcutDisplay } from 'hooks/use-keyboard-shortcuts'

type Props = {
  isCollapsed: boolean
  onToggleCollapse: () => void
}

/**
 * Catalog's filter sidebar — mounts `ControlsSidebar` with only the `filter`
 * section, the same component/section Charts/Feedback/Keywords use. All
 * store wiring lives in the co-located `useCatalogFilterSidebar` hook; this
 * component stays a pure view over its result. Replaces the old
 * `CatalogSidebar` (which rendered the item list) — the item list now lives
 * in the main body as `CatalogTable`, so this sidebar is a pure query
 * builder, nothing else.
 */
export const CatalogFilterSidebar: React.FC<Props> = ({
  isCollapsed,
  onToggleCollapse,
}) => {
  const shortcut = useShortcutDisplay(
    GLOBAL_SHORTCUT_KEYS.NESTED_SIDEBAR_TOGGLE,
  )
  const sidebar = useCatalogFilterSidebar()
  if (!sidebar) return null

  return (
    <ControlsSidebar
      sections={['filter']}
      header={{
        isCollapsed,
        onToggleCollapse,
        title: 'Filter',
        collapseTooltip: (
          <ShortcutTooltip label="Hide filters" shortcut={shortcut} />
        ),
        expandTooltip: (
          <ShortcutTooltip label="Show filters" shortcut={shortcut} />
        ),
      }}
      filter={sidebar}
    />
  )
}
